export default {
  PAGE_TITLE: "アンケート完了",
  ANSWER_CONTENT: "回答内容",
  THANK_YOU_ANSWER: "アンケートへご協力いただき\nありがとうございました",
};
